import useAuth from "@/hooks/useAuth";
import { SideBarRouteOption, UserRole } from "@/types";
import { DashboardLayout } from "moh-ui";
import { useMemo } from "react";
import { BsFillGearFill } from "react-icons/bs";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { Outlet, useNavigate } from "react-router-dom";
import AddUpdateCouncil from "../modals/control-panel/AddUpdateCouncil";
import DeleteCouncilModal from "../modals/control-panel/DeleteCouncil";
import AddUpdateApprovalStructure from "../modals/licencing-admin/AddUpdateApprovalStructure";
import DeleteApprovalStructureModal from "../modals/control-panel/DeleteApprovalStructure";
import AddUpdateStudyLevel from "../modals/control-panel/AddUpdateStudyLevel";
import DeleteStudyLevelModal from "../modals/control-panel/DeleteStudyLevel";
import AddUpdateFine from "../modals/control-panel/AddUpdateFine";
import DeleteFineModal from "../modals/control-panel/DeleteFine";
import { getCouncilProfileUrl } from "@/services/councils";
import { baseUrl } from "@/axios.config";
import AddUpdateService from "../modals/control-panel/AddUpdateService";

export default function MainLayout({
  routes,
}: {
  routes: SideBarRouteOption[];
}) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const isAdmin = useMemo(() => {
    return user?.roles?.find((role) => role.roleName === UserRole.ADMIN);
  }, [user]);

  const profilePictureUrl = `${baseUrl}/users/profile-picture?pictureName=${user?.profilePicture}`

  return (
    <>
      <AddUpdateCouncil />
      <AddUpdateService/>
      <DeleteCouncilModal />
      <AddUpdateApprovalStructure />
      <DeleteApprovalStructureModal />
      <AddUpdateStudyLevel />
      <DeleteStudyLevelModal />
      <AddUpdateFine />
      <DeleteFineModal />
      <DashboardLayout
        collapsibleSidebar
        layoutMode="vertical"
        navigationProps={{
          routes: routes,
          isItemActive: (path) => {
            return path === location.pathname;
          },
        }}
        topbarProps={{
          user: {
            username: `${user?.firstName + ' ' + user?.lastName}`,
            email: user?.email ?? '',
            profilePicture: user?.profilePicture ? profilePictureUrl : undefined,
          },
          logoProps: {
            title: 'Republic of Rwanda',
            subtitle: isAdmin ? 'Rwanda Health Council Connect (RHCC)' : user?.usercouncil[0].councilName ?? "Rwanda Health Council Connect (RHCC)",
            onClick: () => navigate('/' + location.pathname.split('/')[1]),
            customLogo: isAdmin ? undefined : user?.usercouncil[0].councilProfileDocumentPath ? (
              <img
                src={getCouncilProfileUrl(user?.usercouncil[0].councilProfileDocumentPath)}
                alt="Council Logo"
                className="h-12 w-12 rounded-full object-cover"
              />
            ) : undefined
          },
          notificationProps: {
            notifications: [],
            markAllAsRead: () => { },
            markNotificationAsRead: () => { },
          },
          profileDropdownItems: [
            {
              label: 'Account Settings',
              icon: <BsFillGearFill size={20} />,
              onClick: () => navigate('/' + location.pathname.split('/')[1] + '/profile'),
            },
            {
              label: 'Logout',
              icon: <RiLogoutCircleRLine size={20} />,
              onClick: () => logout(),
            },
          ],
        }}
      >
        <Outlet />
      </DashboardLayout>
    </>
  );
}
